import type { ElementType, HTMLAttributes, ReactElement } from "react";
import styles from "./Container.module.css";

export type ContainerWidth = "default" | "prose" | "wide" | "full";

export interface ContainerProps extends HTMLAttributes<HTMLElement> {
  /**
   * Max content width. `prose` caps to a readable measure, `wide` to the
   * table-view measure (a data grid needs more room than prose), `full`
   * removes the cap.
   */
  width?: ContainerWidth;
  /** Semantic element to render (defaults to a plain `div`). */
  as?: ElementType;
}

/**
 * Horizontal layout primitive: centres content and applies a responsive inline
 * gutter, capping the line length at a token-defined max width. Every view
 * composes its content inside a Container.
 */
export function Container({
  width = "default",
  as: Component = "div",
  className,
  children,
  ...rest
}: ContainerProps): ReactElement {
  const classes = [styles.container, styles[width], className].filter(Boolean).join(" ");
  return (
    <Component className={classes} {...rest}>
      {children}
    </Component>
  );
}
